module.exports = __webpack_public_path__ + "img/global-distribution.c05788fd.png";